import styled from "styled-components";
import { StatusTag } from "../Table/dataGridPro";
import {
  AlarmIcon,
  CheckCircleIcon,
  InfoOutlinedIcon,
} from "../../theme/icons";

const Badge = styled(StatusTag)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: auto;
  height: 24px;
  box-sizing: border-box;
  padding: 2px 8px;
  font-size: 13px;
  font-weight: normal;
  flex-shrink: 0;
  cursor: default;
  svg {
    font-size: 14px;
  }
`;

const ReportReviewStatusBadge = ({ className = "", children }) => (
  <Badge as="span" className={className}>
    {className === "alarm" ? (
      <AlarmIcon />
    ) : className === "resolved" ? (
      <CheckCircleIcon />
    ) : (
      <InfoOutlinedIcon />
    )}
    <span>{children}</span>
  </Badge>
);

export default ReportReviewStatusBadge;
